import React, { useState, useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Input, Button, FormGroup, Label, InputGroup, InputGroupAddon } from 'reactstrap';
import Select, { components } from 'react-select';
import { toast } from 'react-toastify';
import { cloneDeep, isBuffer } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import TextUtils from '../../helpers/TextUtils';
import NumberFormat from 'react-number-format';
import AsyncSelect from "react-select/async";
import { PaymentMethodList } from '../designation/DesignationAdd';
import BatchAdd from '../batch/BatchAdd';
import queryString from 'query-string';
import PaymentAdd from '../payment/PaymentAdd';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import moment from 'moment';
import IconCalendar from '../../assets/images/icon/ic_calendar-black.svg';
import { RenderActionModal } from './StockCancelList';
import StockCancelImages from './components/StockCancelImages';
import ProductUtil from '../../helpers/ProductUtil';

const Detail = (props: any) => {
    const {from, closeModal, fetchCustomerExam} = props
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(props?.match?.params?.id);
    const [onlyView, setOnlyView] = useState(false);
    const [data, setData] = useState({
        branch_id: props?.user?.branch_id?.id,
        day: moment().valueOf()
    });
    const [product, setProduct] = useState<any>([{
        product_id: "",
        quantity:"",
        unit_id:"",
    }])
    const [productTemplate, setProductTemplate] = useState<any>()
    const [stockRequestTemplate, setStockRequestTemplate] = useState<any>()
    const [modalIsOpen, setIsOpen] = useState(false);
    const [type, setType] = useState(props?.match?.params?.action);
    const [action, setAction] = useState<any>();
    const [branch, setBranch] = useState<any>([]);
    const [supplier, setSupplier] = useState<any>([]);
    const [supplierInfo, setSupplierInfo] = useState<any>();
    const [payment, setPayment] = useState<any>([{
        product_id: "",
        quantity:"",
    }])
    const [imgs, setImgs] = useState<any>([]);
    const [history, setHistory] = useState<any>();
    const router = useHistory()

    const loadHistory = async (id:number) => {
        const url = `${baseUrl}/stock/cancel/history/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response?.data;
            setHistory(resData)
        }
    }
    const searchPrams = queryString.parse(props.location.search)

    useEffect(() => {
        if (id && id !== 'add') {
            loadData(id)
            document.title = 'Chỉnh sửa phiếu xuất hỏng hủy'
            
        }else{
            document.title = 'Thêm mới phiếu xuất hỏng hủy'
        }
        if (type === 'view') {
            setOnlyView(true)
            loadHistory(id)
            document.title = 'Chi tiết phiếu xuất hỏng hủy'
        }
    }, [id]);

    useEffect(() => {
        if (searchPrams?.stockrequest_id) {
            loadDataByStockRequest(Number(searchPrams?.stockrequest_id))
        }
    }, [searchPrams?.stockrequest_id]);

    useEffect(() => {
        loadInit()
    }, []);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }
    
    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseBranch,
            responseProductTemplate,
            responseStockRequest,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/branch`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/product`, {...params, include_price_cost:true, include_product_stock:true, limit:10}),
            APIClient.GET(`${baseUrl}/stock/request`, {
                ...params,
                status: undefined
            }),
        ]);
        if (responseBranch.response?.data !== undefined) {
            let ListArr:any = [];
            responseBranch.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBranch(ListArr)
        }
        if (responseProductTemplate.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(responseProductTemplate.response?.data)
            setProductTemplate(ListArr)
        }
        if (responseStockRequest.response?.data !== undefined) {
            let ListArr:any = [];
            responseStockRequest.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.code
                })
            })
            setStockRequestTemplate(ListArr)
        }
    }

    const loadData = async (id:number) => {
        const url = `${baseUrl}/stock/cancel/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            if(!resData) router?.push(`/stockcancel/list`)
            const resDataProduct = response.response?.stock_cancel_products?.reduce((prev:any, item:any)=>{
                const product_units_lockup:any = {}
                product_units_lockup['root'] = {
                    name: item?.product_id?.minimum_unit,
                    quantity_conversion: 1,
                }
                item?.product_id?.product_units?.map((itemUnit:any)=>{
                    product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
                })
                const product_variants = item?.product_id?.product_variants
                //stock
                const product_stock_lockup:any = {}
                item?.product_id?.product_stock?.map((itemStock:any)=>{
                    if(!product_stock_lockup[itemStock?.variant_id?.id || 'root']) product_stock_lockup[itemStock?.variant_id?.id || 'root'] = {}
                    if(!product_stock_lockup[itemStock?.variant_id?.id || 'root'][itemStock?.branch_id?.id]) product_stock_lockup[itemStock?.variant_id?.id || 'root'][itemStock?.branch_id?.id] = {}
                    if(!product_stock_lockup[itemStock?.variant_id?.id || 'root'][itemStock?.branch_id?.id][itemStock?.batch_id?.id || 'root']) product_stock_lockup[itemStock?.variant_id?.id || 'root'][itemStock?.branch_id?.id][itemStock?.batch_id?.id || 'root'] = {}
                    product_stock_lockup[itemStock?.variant_id?.id || 'root'][itemStock?.branch_id?.id][itemStock?.batch_id?.id || 'root'] = Number(itemStock?.quantity)
                })
                //unit
                const product_variants_units:any = ProductUtil.parseProductUnit(item?.product_id, product_variants, product_units_lockup)
                let itemRoot = {
                    name: item?.product_id?.name,
                    sku: item?.product_id?.sku,
                    stock_max: item?.product_id?.stock_max,
                    stock_min: item?.product_id?.stock_min,
                    type: item?.product_id?.type,
                    status: item?.product_id?.status,
                    height: item?.product_id?.height,
                    weight: item?.product_id?.weight,
                    width: item?.product_id?.width,
                    longs: item?.product_id?.longs,
                    vat: item?.product_id?.vat,
                    price: item?.product_id?.price,
                    price_cancel: item?.product_id?.price_cancel,
                    price_wholesale: item?.product_id?.price_wholesale,
                    price_cost: item?.price_cost,
                    product_id: item?.product_id?.id,
                    variant_id: null,
                    value: `${item?.id}`,
                    label: item?.product_id?.name,
                    units: product_variants_units,
                    batchs: ProductUtil.parseProductBatch(item?.product_id?.product_batchs || []),
                    stock_quantity: product_stock_lockup
                }
                if(item?.variant_id){
                    const itemVariant = item?.variant_id
                    const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                    itemRoot = {
                        ...itemRoot,
                        name: itemVariant?.name,
                        sku: itemVariant?.sku,
                        vat: itemVariant?.vat,
                        price: item?.price,
                        price_cancel: itemVariant?.price_cancel,
                        price_wholesale: itemVariant?.price_wholesale,
                        product_id: item?.id,
                        variant_id: itemVariant?.id,
                        value: `${item?.id}-${itemVariant?.id}`,
                        label: itemVariant?.name,
                        units: product_variants_units,
                        batchs: ProductUtil.parseProductBatch(itemVariant?.product_batchs || []),
                        stock_quantity: product_stock_lockup
                    }
                }
                prev = [...prev, {
                    product_id: item?.product_id?.id,
                    variant_id: item?.variant_id?.id,
                    product: itemRoot,
                    quantity: item?.quantity,
                    quantity_request: item?.quantity_request,
                    price: item?.price,
                    price_request: item?.price_request,
                    discount: item?.discount,
                    unit_id: item?.unit_id?.id || 0,
                    batch_id: item?.batch_id?.id || 0,
                }]
                return prev
            },[]);
            const dataTemp:any = {
                ...resData,
                branch_id: resData.branch_id?.id,
                branch_id_to: resData.branch_id_to?.id,
                supplier_id: resData.supplier_id?.id,
                stock_request_id: resData.stock_request_id?.id,
            }
            setData(dataTemp)
            setProduct(resDataProduct)
            setPayment(resData?.stock_cancel_payments)
            setSupplierInfo(resData.supplier_id)
            setImgs(resData?.images)
        }
    }

    const loadDataByStockRequest = async (id:number) => {
        const url = `${baseUrl}/stock/request/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const resDataProduct = response.response?.stock_request_products?.reduce((prev:any, item:any)=>{
                const product_units_lockup:any = {}
                product_units_lockup['root'] = {
                    name: item?.product_id?.minimum_unit,
                    quantity_conversion: 1,
                }
                item?.product_id?.product_units?.map((itemUnit:any)=>{
                    product_units_lockup[itemUnit?.quantity_conversion] = itemUnit
                })
                const product_variants = item?.product_id?.product_variants
                const product_variants_units:any = ProductUtil.parseProductUnit(item?.product_id, product_variants, product_units_lockup)
                let itemRoot = {
                    name: item?.product_id?.name,
                    sku: item?.product_id?.sku,
                    stock_max: item?.product_id?.stock_max,
                    stock_min: item?.product_id?.stock_min,
                    type: item?.product_id?.type,
                    status: item?.product_id?.status,
                    height: item?.product_id?.height,
                    weight: item?.product_id?.weight,
                    width: item?.product_id?.width,
                    longs: item?.product_id?.longs,
                    vat: item?.product_id?.vat,
                    price: item?.product_id?.price,
                    price_cancel: item?.product_id?.price_cancel,
                    price_wholesale: item?.product_id?.price_wholesale,
                    product_id: item?.product_id?.id,
                    variant_id: null,
                    value: `${item?.id}`,
                    label: item?.product_id?.name,
                    units: product_variants_units,
                    batchs: ProductUtil.parseProductBatch(item?.product_id?.product_batchs || [])
                }
                if(item?.variant_id){
                    const itemVariant = item?.variant_id
                    const product_variants_units:any = ProductUtil.parseProductUnit(itemVariant, product_variants, product_units_lockup)
                    itemRoot = {
                        ...itemRoot,
                        name: itemVariant?.name,
                        sku: itemVariant?.sku,
                        vat: itemVariant?.vat,
                        price: itemVariant?.price,
                        price_cancel: itemVariant?.price_cancel,
                        price_wholesale: itemVariant?.price_wholesale,
                        product_id: item?.id,
                        variant_id: itemVariant?.id,
                        value: `${item?.id}-${itemVariant?.id}`,
                        label: itemVariant?.name,
                        units: product_variants_units,
                        batchs: ProductUtil.parseProductBatch(itemVariant?.product_batchs || [])
                    }
                }
                prev = [...prev, {
                    product_id: item?.product_id?.id,
                    variant_id: item?.variant_id?.id,
                    product: itemRoot,
                    quantity: item?.quantity,
                    quantity_request: item?.quantity,
                    price: itemRoot?.price_cancel,
                    price_request: item?.price_request,
                    discount: item?.discount,
                    unit_id: item?.unit_id?.id || 0,
                    batch_id: item?.batch_id?.id || 0,
                }]
                return prev
            },[]);
            const dataTemp:any = {
                ...resData,
                code: null,
                branch_id: resData.branch_id?.id,
                stock_request_id: id,
            }
            console.log("resDataProduct", resDataProduct)
            setData(dataTemp)
            setProduct(resDataProduct)
        }
    }

    const handleUpdateBatch = (dataBatch:any, product_id:number, variant_id:number, indexProduct:number)=>{
        const products = product?.filter((item:any)=>{
            return item?.product_id === product_id && item?.variant_id === variant_id
        })
        let curBatch = products && products[0] && products[0]?.product && products[0]?.product?.batchs || []
        let newBatch = [...curBatch, ...ProductUtil.parseProductBatch(dataBatch)]
        if(products && products[0] && products[0]?.product){
            //update lại số lô
            product?.map((item:any, index:number)=>{
                if(item?.product_id === product_id && item?.variant_id === variant_id){
                    product[index].product.batchs = newBatch
                }
            })
            //set lại lô cho sp đang sửa
            product[indexProduct].batch_id = dataBatch[0]?.id 
            product[indexProduct].quantity = dataBatch[0]?.quantity_cancel
            const newProductBatch = dataBatch?.reduce((prev:any, item:any, index:number)=>{
                if(0 !== index){
                    prev = [...prev,{
                        ...products[0],
                        batch_id: item?.id,
                        quantity: item?.quantity_cancel
                    }]
                }
                return prev
            },[])
            setProduct([...product, ...newProductBatch])
        }
        
    }

    return (
        <div style={{paddingBottom:50}}>
            <React.Fragment>
                {
                    !from &&
                    <PageTitle
                        breadCrumbItems={[
                            { label: `${type == 'view' ? 'Xem chi tiết' : id !== 'add' ? 'Chỉnh sửa' : 'Thêm mới'} phiếu xuất hỏng hủy`, active: true },
                        ]}
                        title={`${type == 'view' ? 'Xem chi tiết' : id !== 'add' ? 'Chỉnh sửa' : 'Thêm mới'} phiếu xuất hỏng hủy`}
                    />
                }
                <ContentPage 
                    data={data}
                    history={history}
                    supplier={supplier}
                    setData={(val:any) => setData(val)}
                    supplierInfo={supplierInfo}
                    setSupplierInfo={(val:any) => setSupplierInfo(val)}
                    branch={branch}
                    product={product}
                    productTemplate={productTemplate}
                    stockRequestTemplate={stockRequestTemplate}
                    setProduct={(val:any) => setProduct(val)}
                    onlyView={onlyView}
                    id={id}
                    type={type}
                    action={action}
                    handleActionModal={(data:any) => handleActionModal(data)}
                    from={from}
                    closeModal={closeModal}
                    fetchCustomerExam={fetchCustomerExam}
                    payment={payment}
                    setPayment={setPayment}
                    imgs={imgs}
                    setImgs={setImgs}
                />
                <ModalPopup
                    isOpen={modalIsOpen}
                    onRequestClose={() => setIsOpen(false)}
                >
                {action?.type === 'addBatch' ? 
                    <BatchAdd closeModal={() => setIsOpen(false)} action={action} onUpdateBatch={handleUpdateBatch} 
                    product_name={action?.data?.product?.name} 
                    product_id={action?.data?.product_id} 
                    variant_id={action?.data?.variant_id} 
                    sku={action?.data?.product?.sku} 
                    indexProduct={action?.indexProduct} 
                    />
                :action?.type === 'addPayment' ? 
                <PaymentAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} cancel_id={action?.cancel_id} />
                :<RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} />
                }
                    
                </ModalPopup>
                {loading && <Loader />}
            </React.Fragment>
        </div>
    );
};

const ContentPage = (props:any) => {
    const {supplierInfo, setSupplierInfo,setImgs,history, imgs, data, type, setData, branch, onlyView, id, setProduct, product, productTemplate, stockRequestTemplate, supplier, payment, setPayment, action, handleActionModal, 
    from} = props
    const [loading, setLoading] = useState(false)
    const router = useHistory()
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone" || name === "guardian_phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        if(value?.length > 1000) return;
        setData({
            ...data,
            [name]: value
        })
    }

    const handleProductAdd = () => {
        const newDetailtiveUser = {
            product_id: "",
            variant_id: "",
            product: {},
            quantity:"",
        };
        setProduct([...product, newDetailtiveUser]);
    };

    const handleProductUpdate = (dataDetail: any, index: number) => {
        // check xem đã có sp kia trong danh sách chưa nha
        const checkIsset = product?.reduce((prev:any, item:any, indexCheck:number)=>{
            if(indexCheck !== index && item?.product_id === dataDetail?.product_id && item?.variant_id === dataDetail?.variant_id){
                if(dataDetail?.product?.type !== 'batch'){
                    prev = false
                }else if(dataDetail?.product?.type === 'batch' && item?.batch_id === dataDetail?.batch_id){
                    prev = false
                } 
            }
            return prev
        }, true)
        if(!checkIsset){
            toast.warning('Sản phẩm đã được thêm')
            return
        }
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser[index] = dataDetail;
        setProduct(newDetailtiveUser);
    };

    const handleProductRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(product);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser.push({
            product_id: "",
            variant_id: "",
            product_info: {},
            quantity:"",
        })
        setProduct(newDetailtiveUser);
    };

    const validationFrom = () => {
        if (!data.branch_id) {
            toast.warning('Cơ sở chuyển không được để trống!');
            return false
        }
        if (!data.day) {
            toast.warning('Ngày hủy không được để trống!');
            return false
        }
        
        const checkProduct = product?.reduce((prev:any, item:any)=>{
            if(
                !item?.product_id
                || !item?.quantity
                || (item?.product?.type === 'batch' && !item?.batch_id)
            ){
                prev = false
            }
            return prev
        }, true)
        if (!checkProduct) {
            toast.warning('Nhập đầu đủ thông tin sản phẩm');
            return false
        }
        const checkProductQuantity = product?.reduce((prev:any, item:any)=>{
            let stock_quantity = item?.product?.stock_quantity && item?.product?.stock_quantity[item?.variant_id || 'root'] 
            && item?.product?.stock_quantity[item?.variant_id || 'root'][data?.branch_id || 'root']
            &&item?.product?.stock_quantity[item?.variant_id || 'root'][data?.branch_id || 'root'][item?.batch_id || 'root'] || 0
            if(item?.product?.type === 'batch' && !item?.batch_id) stock_quantity = 0

            if(
                Number(item?.quantity || 0) > Number(stock_quantity || 0)
            ){
                prev = false
            }
            return prev
        }, true)
        if (!checkProductQuantity) {
            toast.warning('Số lượng hủy phải nhỏ hơn tồn kho hiện tại');
            return false
        }

        return true
    }
    
    const handleSubmit = async(type?:string) => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/stock/cancel`;
        const stock_cancel_products = product?.reduce((prev:any, item:any)=>{
            let stock_quantity = item?.product?.stock_quantity && item?.product?.stock_quantity[item?.variant_id || 'root'] 
            && item?.product?.stock_quantity[item?.variant_id || 'root'][data?.branch_id || 'root']
            &&item?.product?.stock_quantity[item?.variant_id || 'root'][data?.branch_id || 'root'][item?.batch_id || 'root'] || 0
            if(item?.product?.type === 'batch' && !item?.batch_id) stock_quantity = 0
            const price_cost = item?.product?.price_cost && item?.product?.price_cost[data?.branch_id] && item?.product?.price_cost[data?.branch_id]?.price_cost
            prev = [...prev,{
                "product_id": item?.product_id,
                "variant_id": item?.variant_id || undefined,
                "quantity": Number(item?.quantity || 0),
                "quantity_stock": Number(stock_quantity || 0),
                "price_cost": Number(price_cost || 0),
                "unit_id": item?.unit_id ? item?.unit_id : undefined,
                "batch_id": item?.batch_id ? item?.batch_id : undefined,
            }]
            return prev
        },[])
        const params = {
            "branch_id": data?.branch_id,
            "code": data?.code,
            "day": moment(data?.day).startOf('days').valueOf(),
            "note": data?.note,
            "status": type === 'active' ? 1 : type === 'export' ? 2 : 0,
            "stock_cancel_products": stock_cancel_products,
            "images": imgs,
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo mới phiếu xuất hỏng hủy thành công')
            router?.push(`/stockcancel/${response.response?.id}/view`)
        }
    }

    const handleEdit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/stock/cancel/${id}`;
        const stock_cancel_products = product?.reduce((prev:any, item:any)=>{
            let stock_quantity = item?.product?.stock_quantity && item?.product?.stock_quantity[item?.variant_id || 'root'] 
            && item?.product?.stock_quantity[item?.variant_id || 'root'][data?.branch_id || 'root']
            &&item?.product?.stock_quantity[item?.variant_id || 'root'][data?.branch_id || 'root'][item?.batch_id || 'root'] || 0
            if(item?.product?.type === 'batch' && !item?.batch_id) stock_quantity = 0
            const price_cost = item?.product?.price_cost && item?.product?.price_cost[data?.branch_id] && item?.product?.price_cost[data?.branch_id]?.price_cost
            prev = [...prev,{
                "product_id": item?.product_id,
                "variant_id": item?.variant_id || undefined,
                "quantity": Number(item?.quantity || 0),
                "quantity_stock": Number(stock_quantity || 0),
                "price_cost": Number(price_cost || 0),
                "unit_id": item?.unit_id ? item?.unit_id : undefined,
                "batch_id": item?.batch_id ? item?.batch_id : undefined,
            }]
            return prev
        },[])
        const params = {
            "branch_id": data?.branch_id,
            "code": data?.code,
            "day": moment(data?.day).startOf('days').valueOf(),
            "note": data?.note,
            "status": type === 'active' ? 1 : type === 'export' ? 2 : 0,
            "stock_cancel_products": stock_cancel_products,
            "images": imgs,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chỉnh sửa phiếu xuất hỏng hủy thành công')
            router?.push(`/stockcancel/${response.response?.id}/view`)
        }
    }

    const calCount = ()=>{
        const total = product?.reduce((prev:any, item:any)=>{
            if(item?.quantity) prev = prev + (Number(item?.quantity || 0) )
            return prev
        },0)
        return Math.floor(total || 0)
    }

    const calTotal = ()=>{
        const totalPayment = product?.reduce((prev:any, item:any)=>{
            const price_cost = item?.product?.price_cost && item?.product?.price_cost[data?.branch_id] && item?.product?.price_cost[data?.branch_id]?.price_cost
            if(item?.quantity) prev = prev + (Number(price_cost ||  0) * Number(item?.quantity || 0))
            return prev
        },0)
        return Math.floor(totalPayment || 0)
    }

    const getLabelStatus = (status:any) => {
        switch(status) {
            case -1: {
                return <span className="ml-2 label-status bg-danger">Từ chối</span>
                break;
            }
            case 0: {
                return <span className="ml-2 label-status bg-dark">Mới</span>
                break;
            }
            case 1: {
                return <span className="ml-2 label-status bg-success">Đã duyệt</span>
                break;
            }
            default: {
                return null
                break;
            }
        }
    }
    
    const handleChangeDate = (date: any) => {
        setData({
            ...data,
            day: date[0] ? moment(date[0]) : undefined
        })
    }

    return (
        <PageContent style={from=='exam' ? {width:'900px', maxHeight:'80vh', overflowX:'hidden'}: {}} className={onlyView ? 'only-view' : ''}>
            <Row>
                <Col md={9} xs={12}>
                    <PageBody>
                        <div className="nutri-title mb-3">Thông tin phiếu xuất hỏng hủy {getLabelStatus(data?.status)}</div>
                        <Row>
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Mã phiếu</Label>
                                    {type === 'view' ?
                                        <ValueText className='only-view'>{data?.code}</ValueText>
                                        :<Input type="text" value={data?.code} onChange={(e: any) => handleChangeInput(e)} name="code" placeholder={(type=='view' && !data?.code) ? "---" : "Nhập mã phiếu"} />
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span> Kho (Chi nhánh) hủy</Label>
                                    <Select
                                        placeholder="Chọn cơ sở"
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        isDisabled={onlyView}
                                        onChange={(val: any) => {
                                            setData({ ...data, branch_id: val?.value })
                                        }}
                                        value={branch?.filter(
                                            (option: any) => data?.branch_id == option.value
                                        )}
                                        options={branch}
                                        components={{ Menu: (props:any)=>(
                                            <components.Menu {...props} >
                                                {props.children}
                                                <Link to="/setting/medicalbasis/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                                    <i className="uil-plus mr-1"></i> Tạo mới cơ sở
                                                </Link>
                                            </components.Menu>
                                        )}}
                                        styles={{
                                            ...customStyles,
                                            menu: ({ width, ...css }) => ({
                                                ...css,
                                                minWidth: 400,
                                            }),
                                        }}
                                    ></Select>
                                </FormGroup>
                            </Col>
                            
                            <Col md={3} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Ngày hủy</Label>
                                    <InputGroup>
                                        <Flatpickr
                                            value={[new Date(data?.day)]}
                                            onChange={(date: any) => handleChangeDate(date)}
                                            options={{
                                                locale: Vietnamese,
                                                allowInput:true,
                                                dateFormat: "d/m/Y",
                                                altInputClass : "date-range",
                                                minDate:'today'
                                            }}
                                            placeholder="dd/mm/yy"
                                        />
                                        {
                                            type!='view' &&
                                            <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                                <img src={IconCalendar} alt="icon" />
                                            </InputGroupAddon>
                                        }
                                    </InputGroup>
                                    
                                </FormGroup>
                            </Col>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Ghi chú</Label>
                                    <Input type="text" value={data?.note} onChange={(e: any) => handleChangeInput(e)} name="note" placeholder={(type=='view' && !data?.note) ? "---" : "Nhập ghi chú"} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </PageBody>
                    <PageBody>
                        <div className="nutri-title mb-3">Sản phẩm</div>
                        <div className="table-responsive" style={{overflow: 'unset'}}>
                            <table className="mb-0 table-custom no-bg table table-input" >
                                <thead>
                                    <tr>
                                        <th style={{ width: '20%' }}><span className='require'>*</span> Tên sản phẩm</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span> Mã SKU</th>
                                        <th style={{ width: '10%' }}>Mã Lô</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span> Đơn vị</th>
                                        <th style={{ width: '10%' }}>Tồn kho</th>
                                        <th style={{ width: '10%' }}><span className='require'>*</span>SL hủy</th>
                                        {!onlyView &&<th style={{ width: '4%' }}></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    product?.map((item:any, index:number) => (
                                        <ProductItem 
                                            key={`item-product-${index}`}
                                            handleActionModal={handleActionModal}
                                            detailIndex={index} 
                                            data={item}
                                            dataParent={data}
                                            onChangeData={(dataDetail: any) =>
                                                handleProductUpdate(dataDetail, index)
                                            }
                                            productTemplate={productTemplate}
                                            type={type}
                                            onlyView={onlyView}
                                            handleRemoveData={() => handleProductRemove(index)}
                                            handleAddData={() => handleProductAdd()}
                                            detail={product}
                                        />
                                    ))
                                }
                                </tbody>
                            </table>
                            <Col md={5} style={{float: 'right'}}>
                                <div style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Tổng số lượng </ValueTextLabel>
                                    <ValueTextValue className='only-view' style={{flexDirection: 'row-reverse'}}>{PriceUtils.format(calCount(),'')}</ValueTextValue>
                                </div>
                                <div style={{ display: 'flex', justifyContent:'space-between', width: '100%'}}>
                                    <ValueTextLabel>Tổng giá trị hỏng hủy </ValueTextLabel>
                                    <ValueTextValue className='only-view' style={{flexDirection: 'row-reverse'}}>{PriceUtils.format(calTotal())}</ValueTextValue>
                                </div>
                            </Col>
                            
                        </div>
                        
                    </PageBody>
                </Col>
                <Col md={3} xs={12}  className="stock-img-minimal">
                    <StockCancelImages {...props} setImgs={setImgs} imgs={imgs} disabled={onlyView} />
                    {type === 'view' && <History history={history}/>}
                </Col>
            </Row>
            {
                <div className="bottom-action">
                    <Button color="success" className='dark-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                    {
                        id === 'add' && 
                        <>
                            <Button color="success" className='success-bland ml-2' onClick={() => props?.handleActionModal({type: 'activeConfirm', data: data, onSubmit:()=>handleSubmit('active')})}>Đã duyệt</Button>
                            <Button color="success" className='ml-2' onClick={()=>handleSubmit()}>Lưu</Button>
                        </>
                    }
                    {
                        id && type == 'view' && data?.status == 0 && 
                        <>
                            <Button color="success" className='success-bland ml-2' onClick={() => props?.handleActionModal({type: 'active', data: data})}>Đã duyệt</Button>
                            <Button color="success" className='danger-bland ml-2' onClick={() => props?.handleActionModal({type: 'reject', data: data})}>Từ chối</Button>
                            <Button color="danger" className=' ml-2' onClick={() => props?.handleActionModal({type: 'delete', data: data})}>Xóa phiếu</Button>
                            <Button color="success" className='ml-2' onClick={() => router?.push(`/stockcancel/${id}`)}>Chỉnh sửa</Button>
                        </>
                    }
                    {
                        id !== 'add' && type != 'view' && data?.status == 0 &&
                        <Button color="success" className='ml-2' onClick={handleEdit}>Lưu</Button>
                    }
                </div>
            }
            
            {loading && <Loader />}
        </PageContent>
    )
}

const ProductItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, dataParent, productTemplate, type, onlyView, handleRemoveData, handleAddData, handleActionModal} = props
    const [loadingDesignation, setLoadingProduct] = useState(false);
    const [queryDesignation, setQueryDesignation] = useState('')

    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        onChangeData({
            ...data,
            [name]: value
        })
    }

    const loadProduct = async () => {
        setLoadingProduct(true)
        let response: any = await APIClient.GET(`${baseUrl}/product`,{
            page: 1,
            limit: 20,
            include_price_cost:true,
            include_product_stock:true,
            name: queryDesignation
        });
        setLoadingProduct(false)
        if (response.response?.data !== undefined) {
            const ListArr = ProductUtil.parseProduct(response.response?.data)
            return ListArr
        }else{
            return []
        }
    };

    const handleInputChangeProduct = (newValue:any) => {
        setQueryDesignation( newValue);
        return newValue;
    };

    let stock_quantity = data?.product?.stock_quantity && data?.product?.stock_quantity[data?.variant_id || 'root'] 
    && data?.product?.stock_quantity[data?.variant_id || 'root'][dataParent?.branch_id || 'root']
    &&data?.product?.stock_quantity[data?.variant_id || 'root'][dataParent?.branch_id || 'root'][data?.batch_id || 'root'] || 0
    if(data?.product?.type === 'batch' && !data?.batch_id) stock_quantity = 0

    console.log("stock_quantity", data?.product?.stock_quantity, data?.variant_id, dataParent?.branch_id, stock_quantity)

    return (
        <tr key={`item-product-${detailIndex}`}>
            <td onClick={()=>{
                if(!dataParent?.branch_id){
                    toast.warning("Bạn cần chọn chi nhánh chuyển trước")
                }
            }}>
                <AsyncSelect
                    className="react-select"
                    classNamePrefix="react-select"
                    onInputChange={handleInputChangeProduct}
                    loadOptions={loadProduct}
                    inputValue={queryDesignation}
                    placeholder={loadingDesignation ? "Đang tải dữ liệu..." : "Nhập tên, mã..."}
                    noOptionsMessage={() => queryDesignation ? "Không tìm thấy dữ liệu" : 'Nhập tên, mã sản phẩm'}
                    loadingMessage={() => 'searching...'}
                    cacheOptions 
                    defaultOptions={productTemplate}
                    onChange={(val: any) => {
                        onChangeData({
                            ...data,
                            product_id: val?.product_id,
                            variant_id: val?.variant_id || undefined,
                            product: val,
                            batch_id: '',
                            unit_id: 0,
                            quantity: 1,
                            quantity_request: '',
                            price: val?.price_cancel,
                            discount: '',
                        })
                    }}
                    // value={productTemplate?.filter(
                    //     (option: any) => data?.product_id == option.product_id && data?.variant_id == option.variant_id
                    // )}
                    value={{
                        label: data?.product?.name
                    }}
                    isDisabled={onlyView || !dataParent?.branch_id}
                    components={{ Menu: (props:any)=>(
                        <components.Menu {...props} >
                            {props.children}
                            <Link to="/product/add" target="_blank" rel="noopener noreferrer" className='select-menu-add'>
                                <i className="uil-plus mr-1"></i> Tạo mới sản phẩm
                            </Link>
                        </components.Menu>
                    )}}
                    styles={{
                        ...customStyles,
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 500,
                        }),
                    }}
                />
            </td>
            <td>
                <Input type="text" value={data?.product?.sku || ''} disabled={true} placeholder={(type=='view' && !data?.product?.sku) ? "---" : "Mã SKU"} />
            </td>
            {data?.product?.type === 'batch' ?
            <td style={{ width: '13%' }}>
                <Select
                    placeholder={(type=='view' && !data?.batch_id) ? "---" : "Chọn lô..."}
                    className="react-select"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                        onChangeData({
                            ...data,
                            batch_id: val?.value,
                        })
                    }}
                    value={data?.product?.batchs?.filter(
                        (option: any) => data?.batch_id === option.value
                    )}
                    options={data?.product?.batchs}
                    noOptionsMessage={() => 'Chưa có lô'}
                    // components={{ Menu: (props:any)=>(
                    //     <components.Menu {...props} >
                    //         {props.children}
                    //         <div className='select-menu-add' onClick={()=>{
                    //             handleActionModal({type: 'addBatch', data: data, indexProduct: detailIndex})
                    //         }}>
                    //             <i className="uil-plus mr-1"></i> Tạo lô
                    //         </div>
                    //     </components.Menu>
                    // )}}
                    styles={{
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 200,
                        }),
                    }}
                ></Select>
            </td>:<td></td>
            }
            <td>
                <Select
                    placeholder={(type=='view' && !data?.unit_id) ? "---" : "Chọn đơn vị..."}
                    className="react-select"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                        onChangeData({
                            ...data,
                            unit_id: val?.value,
                        })
                    }}
                    value={data?.product?.units?.filter(
                        (option: any) => data?.unit_id === option.value
                    )}
                    options={data?.product?.units}
                    noOptionsMessage={() => 'Chưa có đơn vị'}
                    styles={{
                        ...customStyles,
                        menu: ({ width, ...css }) => ({
                            ...css,
                            minWidth: 200,
                        }),
                    }}
                ></Select>
            </td>
            <td>
                {PriceUtils.format(stock_quantity, '')}
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => {
                        let value = TextUtils.onlyNumber(e.target.value)
                        if(value > stock_quantity) {
                            value = stock_quantity
                            toast.warning("Số lượng chuyển không thể lớn hơn tồn kho")
                        }
                        handleChangeData({ target: { name: 'quantity', value: value } })
                    }}
                    name={'quantity'} type={'text'} className="form-control" 
                    value={type === 'view' && !data?.quantity ? '---': data?.quantity}
                    disabled={onlyView}
                    placeholder={(type=='view' && !data?.quantity) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                />
            </td>
            {(!onlyView && dataParent?.branch_id) &&
            <td>
                {/* <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button> */}
                {
                    detail?.length == detailIndex+1 ?
                    <Button onClick={handleAddData} className='nutri-square' color='success'><i className='uil-plus'></i></Button> :
                    <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                }
            </td>}
        </tr>
    )
}

const History = (props:any)=>{
    const {history} = props
    
    const HistoryItem = ({item}:any)=>{
        if(item?.import_status === 0){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Tạo mới nhập hàng</td>
                </tr>
            )
        }else if(item?.import_status === 1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Xác nhận nhập hàng</td>
                </tr>
            )
        }else if(item?.import_status === 2){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Nhập kho</td>
                </tr>
            )
        }else if(item?.import_status === 3){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Chuyển hoàn</td>
                </tr>
            )
        }else if(item?.import_status === -1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Hủy nhập hàng</td>
                </tr>
            )
        }else if(item?.status === -1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Từ chối</td>
                </tr>
            )
        }else if(item?.updated_uid && item?.status === 1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Duyệt</td>
                </tr>
            )
        }else if(item?.updated_uid){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Cập nhật</td>
                </tr>
            )
        }else if(item?.status === 1){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name}</td>
                    <td>Tạo và duyệt</td>
                </tr>
            )
        }else if(item?.status === 0){
            return(
                <tr>
                    <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td>{item?.updated_uid?.name || item?.created_uid?.name}</td>
                    <td>Tạo mới</td>
                </tr>
            )
        }
        return(
            <tr>
                <td>{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td>{item?.created_uid?.name}</td>
                <td>Tạo mới</td>
            </tr>
        )
    }


    return(
        <PageBody>
            <div className="nutri-title mb-3">Lịch sử thao tác</div>
            <div className="table-responsive" style={{overflow: 'unset'}}>
                <table className="mb-0 table-custom no-bg table table-input" >
                    <thead>
                        <tr>
                            <th style={{ width: '30%' }}>Thời gian</th>
                            <th style={{ width: '30%' }}>Người thực hiện</th>
                            <th style={{ width: '30%' }}>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        history?.map((item:any, index:number) => (
                            <HistoryItem 
                                item={item}
                            />
                        ))
                    }
                    </tbody>
                </table>
            </div>
            
        </PageBody>
    )
}

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
      }),
  };

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!cancelant;
            }
            .react-select__control {
                border:none;
                background-color: transparent!cancelant;
            }
        }
    }
`

const ValueTextLabel = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    flex: 2;
`

const ValueTextValue = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    flex: 3;
`

export default connect(mapState)(Detail)